import React, {useState, useEffect} from 'react';
import classNames from 'classnames';

type TimeLeft = {
  hours: number;
  minutes: number;
  seconds: number;
};

const calculateTimeLeft = (date: Date): TimeLeft | null => {
  const difference = +date - +new Date();

  if (difference <= 0) return null;

  return {
    hours: Math.floor(difference / 1000 / 60 / 60),
    minutes: Math.floor((difference / 1000 / 60) % 60),
    seconds: Math.floor((difference / 1000) % 60),
  };
};

type TimerProps = React.HTMLProps<HTMLDivElement> & {
  expireDate: Date;
};

const Timer = ({className, expireDate, ...props}: TimerProps) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft | null>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const timeLeft = calculateTimeLeft(expireDate);

      if (!timeLeft) {
        return;
      }

      setTimeLeft(timeLeft);
    }, 1000);

    return () => clearTimeout(timeout);
  });

  const hours = (timeLeft?.hours ?? 0).toString().padStart(2, '0');
  const minutes = (timeLeft?.minutes ?? 0).toString().padStart(2, '0');
  const seconds = (timeLeft?.seconds ?? 0).toString().padStart(2, '0');

  return (
    <div className={classNames('Timer', className)} {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' width='144' height='51' viewBox='0 0 144 51'>
        <path
          fill='#F2F2F2'
          fillRule='evenodd'
          d='M4.5.9h138.6l-15.846 43.576c-1.293 3.556-4.673 5.924-8.458 5.924H4.5c-1.988 0-3.6-1.612-3.6-3.6V4.5C.9 2.512 2.512.9 4.5.9z'
        />
      </svg>

      <div className='Timer__title'>חבילה מוזלת לזמן מוגבל</div>

      <div className='Timer__expire-date'>
        {hours}:{minutes}:{seconds}
      </div>
    </div>
  );
};

export default Timer;
